export const CM_FILTERS = Object.freeze({
    TOTAL: 'TOTAL',
    INACTIVE: 'INACTIVE',
    ACTIVE: 'ACTIVE',
    PENDING: 'PENDING',
});

export const CM_FILTER_CARDS = [
    {
        name: 'Total Team Leaders (TLs)',
        type: CM_FILTERS.TOTAL,
        filterValue: {
            type: 'Total',
            subType: '',
            status: '',
        },
        valueMappingKey: 'totalTlCount',
    },
    {
        name: 'Active (online)',
        type: CM_FILTERS.ACTIVE,
        filterValue: {
            type: 'Active',
            subType: '',
            status: 'SIGNED IN',
        },
        valueMappingKey: 'activeTLCount',
    },
    {
        name: 'Inactive (Offline)',
        type: CM_FILTERS.INACTIVE,
        filterValue: {
            type: 'Inactive',
            subType: '',
            status: 'SIGNED OUT',
        },
        valueMappingKey: 'inActiveTLCount',
    },
    {
        name: 'Pending',
        type: CM_FILTERS.PENDING,
        filterValue: {
            type: 'Pending',
            subType: '',
            status: 'PENDING',
        },
        valueMappingKey: 'pendingTLCount',
    },
];
export const TL_FILTER_CARDS = [
    {
        name: 'Total Riders',
        type: CM_FILTERS.TOTAL,
        filterValue: {
            type: 'Total',
            subType: '',
        },
        valueMappingKey: 'evCount',
    },
    {
        name: 'Rider Tagged to EV',
        type: CM_FILTERS.ACTIVE,
        filterValue: {
            type: 'Active',
            subType: '',
        },
        valueMappingKey: 'activeEvCount',
    },
    {
        name: 'Active Riders (with EV)',
        type: CM_FILTERS.INACTIVE,
        filterValue: {
            type: 'Inactive',
            subType: '',
        },
        valueMappingKey: 'inactiveEvCount',
    },
];

export const CM_TABLE_COLUMNS = [
    {
        name: 'Name & contact',
        mappingKey: 'id',
    },
    {
        name: 'Status',
        mappingKey: 'status',
    },
    {
        name: 'Today’s Login',
        mappingKey: 'login',
    },
    {
        name: 'Active Riders',
        mappingKey: 'active_riders',
        valueKey: 'active_riders',
    },
    {
        name: 'EV Deployed | Returned | Net',
        mappingKey: 'ev_deployed',
    },
    {
        name: '',
        mappingKey: 'teamLeadAction',
        actions: true,
    },
];

export const TL_TABLE_COLUMNS = [
    {
        name: 'Name',
        mappingKey: 'name',
    },
    {
        name: 'Hub',
        mappingKey: 'hub',
    },
    {
        name: 'Orders (today)',
        mappingKey: 'orders_today',
    },
    {
        name: 'Wallet Bal (today)',
        mappingKey: 'wallet_balance_today',
    },
    {
        name: 'Decay',
        mappingKey: 'decay',
    },
    {
        name: 'EV Status',
        mappingKey: 'ev_status',
    },
    {
        name: '',
        mappingKey: 'action',
        actions: true,
    },
];

export const PASSBOOK_TABLE_COLUMNS = [
    {
        name: 'Date',
        mappingKey: 'date',
    },
    {
        name: 'Orders',
        mappingKey: 'orders',
    },
    {
        name: 'Earnings',
        mappingKey: 'earnings',
    },
    {
        name: 'Closing Balance',
        mappingKey: 'closing_balance',
    },
    {
        name: '',
        mappingKey: 'action',
        actions: true,
    },
];

export const preProcessPayload = (payload: any) => {
    // Add any additional processing logic here
    let processedPayload = {
        ...payload,
    };
    if (!!payload?.searchText) {
        payload.searchText = payload.searchText.trim();
    } else {
        payload.searchText = '';
    }
    return processedPayload;
};

export const CM_STATUS_TYPES_MAPPING: any = Object.freeze({
    TO_CX: 'none2',
    PENDING: 'pending',
    SIGNED_IN: 'active',
    SIGNED_OUT: 'reject',
    CANCELLED: 'reject',
});

export const TL_CLASS_TYPE_MAPPING: any = Object.freeze({
    VERIFIED: 'active',
    KYC_PENDING: 'pending',
    REJECTED: 'reject',
    INACTIVE: 'inactive',
    PENDING: 'pending',
    ACTIVE: 'active',
    KYC_REJECTED: 'reject',
    TO_CX: 'active',
    IN_STORE: 'pending',
    COMPLETED: 'inactive',
    ON_ORDER: 'active',
    NO_ORDER: 'none',
    ON_BREAK: 'none',
    TO_DX: 'pending',
    OPEN: 'pending',
    RESOLVED: 'active',
    NOT_RESOLVED: 'reject',
    ASSIGNED: 'inactive',
    LIVE: 'active',
    D_PENDING: 'pending',
    D_2: 'pending',
    D_3: 'pending',
    D_4: 'reject',
    D_REJECT: 'reject',
    TAGGED: 'activeWO_BG',
    EV_TAGGED: 'active',
    EV_UNTAG_REQUESTED: 'inactive',
    UNTAGGED: 'rejectWO_BG',
    AVAILABLE: 'inactiveWO_BG',
    RELEASED: 'inactiveWO_BG',
    EV_BIKE_DEPLOYED: 'activeWO_BG',
    RIDER_UNTAG_REQUESTED: 'activeWO_BG',
    RIDER_UNTAG_REQUESTED_REJECTED: 'rejectWO_BG',
    RETURN_DATE_UNTAG_PENDING: 'pendingWO_G',
    RETURN_APPROVAL_PENDING: 'pendingWO_G',
    VEHICLE_RETURN_PENDING: 'pendingWO_G',
    VEHICLE_RETURN_REJECTED: 'rejectWO_BG',
    PROFILE_APPROVAL_PENDING: 'pendingWO_G',
    NOT_TAGGED: 'rejectWO_BG',
    EV_REQUESTED: 'pendingWO_G',
    EV_REQUEST_REJECTED: 'rejectWO_BG',
    'EV_REQUEST REJECTED': 'rejectWO_BG',
    EV_REQUEST_APPROVED: 'activeWO_BG',
    'EV_REQUEST APPROVED': 'activeWO_BG',
    EV_DETAILS_SAVED: 'pendingWO_G',
    'EV_DETAILS SAVED': 'pendingWO_G',
    TAG_REQUEST_REJECTED: 'rejectWO_BG',
    'TAG_REQUEST REJECTED': 'rejectWO_BG',
    TAG_REQUEST_APPROVED: 'activeWO_BG',
    'TAG_REQUEST APPROVED': 'activeWO_BG',
    EV_IN_POSSESSION: 'activeWO_BG',
    EV_IN_Possession: 'activeWO_BG',
    EV_RETURN_REQUESTED: 'pendingWO_G',
    'EV_RETURN REQUESTED': 'pendingWO_G',
    EV_RETURN_REJECTED: 'rejectWO_BG',
    'EV_RETURN REJECTED': 'rejectWO_BG',
    EV_RETURN_APPROVED: 'activeWO_BG',
    'EV_RETURN APPROVED': 'activeWO_BG',
    EV_RETURNED: 'inactiveWO_BG',
});

export const getColorBasedOnValue = (value: string): any => {
    // Extract the number from the string
    const numberMatch = value?.match(/D-(\d+)/);
    if (!numberMatch) return value; // Default color if no match

    const number = parseInt(numberMatch[1]);

    // Determine color based on the extracted number
    if (number <= 3) {
        return 'D_PENDING';
    } else if (number >= 4) {
        return 'D_REJECT';
    }
};

export const getLastPathSegment = () => {
    const pathParts = window?.location?.pathname.split('/')?.filter(Boolean); // Split and remove empty strings
    return pathParts?.[pathParts?.length - 1]; // Get the last segment
};

export function convertRStoAmount(text: string) {
    return Number(text?.replace('Rs', '').trim());
}

export function generateEVWalletPassbookData(historyLineItems: Array<any>) {
    // Parse the historyLineItems and find matching entries
    if (
        !!historyLineItems &&
        Array.isArray(historyLineItems) &&
        !!historyLineItems?.length
    ) {
        const result = historyLineItems.map((item: any, index: number) => {
            let orderCount = 0;
            let earnings = 0;
            let deductions = 0;
            const ordersCount: Array<number> = [];
            // Iterate through subLineItems
            let subLineItems = [];
            if (
                !!item?.subLineItems &&
                Array.isArray(item?.subLineItems) &&
                !!item?.subLineItems?.length
            ) {
                item?.subLineItems?.forEach((subItem: any) => {
                    if (subItem?.leftLabel === 'Earnings') {
                        // Extract order count
                        const orders = parseInt(
                            subItem?.leftValue?.split(' ')?.[0],
                        ); // "6 Orders" -> 6
                        ordersCount.push(orders ?? 0);
                        // Add earnings amount
                        const earningValue = convertRStoAmount(
                            subItem?.rightValue ?? '0',
                        );
                        earnings += earningValue;
                    } else if (subItem?.leftLabel === 'COD deduction') {
                        // Subtract COD deduction
                        const deductionValue = convertRStoAmount(
                            subItem?.rightValue ?? '0',
                        );
                        deductions += deductionValue;
                    }
                    subLineItems.push({
                        ...subItem,
                        label: subItem?.leftLabel ?? '',
                        amount: subItem?.rightValue ?? '',
                    });
                });
            }
            let openingBalance = convertRStoAmount(item?.leftValue ?? '0');
            let closingBalance = convertRStoAmount(item?.rightValue ?? '0');
            if (!!openingBalance) {
                subLineItems.unshift({
                    label: 'Opening Balance',
                    amount: openingBalance,
                    bold: true,
                });
            }
            if (!!closingBalance) {
                subLineItems.push({
                    label: 'Closing Balance',
                    amount: closingBalance,
                    bold: true,
                    divider: true,
                });
            }
            // Return the formatted object
            return {
                ...item,
                date: item?.leftLabel,
                openingBalance: openingBalance,
                orderCount: !!ordersCount?.length
                    ? Math.max(...ordersCount)
                    : 0,
                earnings: earnings + deductions,
                closingBalance: closingBalance,
                subLineItemsUpdated: subLineItems ?? [],
            };
        });
        return result;
    }

    return [];
}
